module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-org"
  }, [_c('ep-title', {
    attrs: {
      "title": "添加单位"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "org-form"
  }, [(_vm.orgState == 0) ? _c('Entform', {
    ref: "addenf",
    on: {
      "change": _vm.onSubmitenf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orgState == 1) ? _c('Govform', {
    ref: "addgov",
    on: {
      "change": _vm.onSubmitgov
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orgState == 2) ? _c('Parkform', {
    ref: "addpark",
    on: {
      "change": _vm.onSubmitpark
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orgState == 3) ? _c('Wtfrom', {
    ref: "addwtf",
    on: {
      "change": _vm.onSubmitwtf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orgState == 4) ? _c('Otherform', {
    ref: "addother",
    on: {
      "change": _vm.onSubmitother
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "org-control"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e700a10","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/unitmanage/addunit.vue
// module id = 1200
// module chunks = 2